export class SignUpData {
    Email: string;
    PatientId: string;
    DefaultPassword: string;
    Username: string;
    Password: string;
    ConfirmPassword: string; 
    Authentication: string;
    IsValid: boolean;
    page: string;
    pageSize: string;
    Pid: string;
    constructor(email: string, patientid: string, defaultpassword: string, username: string, password: string, confirmpassword: string, authen: string) {
        this.Email = email;
        this.PatientId = patientid;
        this.DefaultPassword = defaultpassword;
        this.Username = username;
        this.Password = password;
        this.ConfirmPassword = confirmpassword;
        this.Authentication = authen;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/usersecurity/signupdata.ts